import PoolRankingTabs from './_modules/sportdata/volley/pool-ranking-tabs';
import StandinsStickyHeader from './_modules/sportdata/volley/standings-sticky-header';
window.PoolRankingTabs = new PoolRankingTabs();
window.StandinsStickyHeader = new StandinsStickyHeader();

export default class PoolRankingSticky {
    constructor() {
      this.init();
    }
  
    init() {
      //
    }
  }